import {NEGOTIATION_SNAPSHOT_STATE} from '@/types/negotiationSnapshot';
import type {CampaignCreatorRow} from '../types/creatorTabTypes';

/**
 * A creator with an unresolved brand offer can't be accepted until the
 * negotiation settles. Single source of truth for the grid CTA, the row
 * overflow menu, and the creator-profile header.
 */
export default function hasPendingNegotiation(
  row: CampaignCreatorRow | null | undefined
): boolean {
  return (
    row?.brandNegotiationSnapshot?.brandNegotiation?.state ===
    NEGOTIATION_SNAPSHOT_STATE.pending
  );
}
